import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";
import { IDevice } from "@interfaces/device.interface";

@Injectable({ providedIn: "root" })
@StoreConfig({ name: "device", resettable: true })
export class DeviceStore extends Store<IDevice> {
  constructor() {
    super({
      isScanning: false,
      isOffline: false,
      isScanningForPreviousDevices: false,
      bluetoothIsActive: false,
      reConnectIn: 0,
      currentDevice: {},
      connecting: false,
      scanResult: [],
      previousDevices: [],
      devicesInRange: [],
      functions: [],
      activeFunction: "shake",
      activeFunctionMIC: "shake",
      //characteristicsUuid: '',
      //serviceUuid: '',
      periodicData: [],
      parameterData: [],
      stringParameterData: [],
      hardwareVersions: [],
      parametersForUpdate: [],
      stringParametersForUpdate: [],
      timedOutParameters: [],
      requestUid: "",
      stringRequestUid: "",
      autoCalibrationParameters: [],
      stopAutoCalibrate: false,
      isOldData: false,
      parametersForUpdateServiceTool: [],
      parametersDidUpdateServiceTool: [],
      stringParametersForUpdateServiceTool: [],
      stringParametersDidUpdateServiceTool: [],
      parametersAndStringParametersForBackup: [],
      isBackuping: false,
      profiles: [],
      systemType: "",
    });
  }
}
